import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import store from './store';
import ReactNotification from 'react-notifications-component';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import 'react-notifications-component/dist/theme.css';
import './index.scss';
import AdminApparelItemParts from './components/AdminApparelItemParts';
import AdminApparelItems from './components/AdminApparelItems';
import AdminDepartments from './components/AdminDepartments';
import AdminForms from './components/AdminForms';
import AdminHelpDesk from './components/AdminHelpDesk';
import AdminPromotionalItems from './components/AdminPromotionalItems';
import AdminSizeCharts from './components/AdminSizeCharts';
import AdminUsers from './components/AdminUsers';
import ApparelEditor from './components/ApparelEditor';
import Approve from './components/Approve';
import BrochureEditor from './components/BrochureEditor';
import Department from './components/Department';
import Editor from './components/Editor';
import Favorites from './components/Favorites';
import Landing from './components/Landing';
import Login from './components/Login';
import MyUthealthEditor from './components/MyUthealthEditor';
import NrcEditor from './components/NrcEditor';
import Order from './components/Order';
import Orders from './components/Orders';
import PersonalLogin from './components/PersonalLogin';
import PromotionalEditor from './components/PromotionalEditor';
import Punchout from './components/Punchout';
import Reject from './components/Reject';
import Reports from './components/Reports';
import RestorePassword from './components/RestorePassword';
import Search from './components/Search';
import ShoppingCart from './components/ShoppingCart';
import StaticEditor from './components/StaticEditor';
import Template from './components/Template';
import TermOfUse from './components/TermOfUse';
import UthLanding from './components/UthLanding';
import UtpLanding from './components/UtpLanding';

require('dotenv').config();

if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

ReactDOM.render(
    <Provider store={store}>
        <ReactNotification />
        <Router>
            <Route path="/" exact component={Landing} />
            <Route path="/utp" exact component={UtpLanding} />
            <Route path="/uth" exact component={UthLanding} />
            <Route path="/login" exact component={Login} />
            <Route path="/personal-login" exact component={PersonalLogin} />
            <Route path="/template/:productId/:templateId" exact component={Editor} />
            <Route path="/template/:productId/:templateId/:action" exact component={Editor} />
            <Route path="/order" exact component={Order} />
            <Route path="/orders/:type" exact component={Orders} />
            <Route path="/orders/:type/:action/:id" exact component={Orders} />
            <Route path="/product/:id" exact component={Template} />
            <Route path="/product/:id/:subcategory" exact component={Template} />
            <Route path="/approve/:token" exact component={Approve} />
            <Route path="/reject/:token" exact component={Reject} />
            <Route path="/punchout/:id" exact component={Punchout} />
            <Route path="/department/:productId/:id" exact component={Department} />
            <Route path="/static-template/:productId/:departmentId/:id" exact component={StaticEditor} />
            <Route path="/static-template/:productId/:departmentId/:id/:action" exact component={StaticEditor} />
            <Route path="/apparel-item/:productId/:departmentId/:id" exact component={ApparelEditor} />
            <Route path="/apparel-item/:productId/:departmentId/:id/:ignore" exact component={ApparelEditor} />
            <Route path="/apparel-item/:productId/:departmentId/:id/:ignore/:action" exact component={ApparelEditor} />
            <Route path="/promotional-item/:productId/:departmentId/:id" exact component={PromotionalEditor} />
            <Route path="/promotional-item/:productId/:departmentId/:id/:isMyuth" exact component={PromotionalEditor} />
            <Route path="/promotional-item/:productId/:departmentId/:id/:isMyuth/:action" exact component={PromotionalEditor} />
            <Route path="/search/:productType/:query" exact component={Search} />
            <Route path="/shopping-cart" exact component={ShoppingCart} />
            <Route path="/myuthealth/:type/:id" exact component={MyUthealthEditor} />
            <Route path="/myuthealth/:type/:id/:action" exact component={MyUthealthEditor} />
            <Route path="/nrc/:id" exact component={NrcEditor} />
            <Route path="/nrc/:id/:action" exact component={NrcEditor} />
            <Route path="/brochure/:productId/:departmentId/:id" exact component={BrochureEditor} />
            <Route path="/brochure/:productId/:departmentId/:id/:action" exact component={BrochureEditor} />
            <Route path="/restore-password/:type/:token" exact component={RestorePassword} />
            <Route path="/my-favorites" exact component={Favorites} />
            <Route path="/term-of-use" exact component={TermOfUse} />

            <Route path="/admin/forms" exact component={AdminForms} />
            <Route path="/admin/help-desk" exact component={AdminHelpDesk} />
            <Route path="/admin/promotional-items" exact component={AdminPromotionalItems} />
            <Route path="/admin/apparel-items" exact component={AdminApparelItems} />
            <Route path="/admin/apparel-item-parts/:id" exact component={AdminApparelItemParts} />
            <Route path="/admin/reports" exact component={Reports} />
            <Route path="/admin/departments" exact component={AdminDepartments} />
            <Route path="/admin/departments/:action" exact component={AdminDepartments} />
            <Route path="/admin/departments/:action/:id" exact component={AdminDepartments} />
            <Route path="/admin/size-charts" exact component={AdminSizeCharts} />
            <Route path="/admin/size-charts/:action" exact component={AdminSizeCharts} />
            <Route path="/admin/size-charts/:action/:id" exact component={AdminSizeCharts} />
            <Route path="/admin/users" exact component={AdminUsers} />
        </Router>
    </Provider>,
    document.getElementById('root')
);
